<template>
  <breadCrumbs title="Simple Editor" main="Editors" title1="Simple Editor" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Smiple Editor</h3>
          </div>
          <div class="card-body">
            <quill-editor v-model:value="state.content" :options="state.editorOption"  @change="onEditorChange($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      content: '<h1>Some initial content</h1>',
      _content: '',
      editorOption: {
        placeholder: 'core',
      },
      disabled: false
    })
    const onEditorChange = ({  html}) => {

      state._content = html
    }

    setTimeout(() => {
      state.disabled = true
    }, 2000)

    return { state, onEditorChange }
  },
};
</script>